var $ = window.$;

export default function() {
    $('.sub_cont li').on({
        mouseenter: function() {
            $(this).find('.mega_menu').stop().slideDown('fast');
        },
        mouseleave: function() {
            $(this).find('.mega_menu').stop().slideUp('fast');
        },
    });
}



// WEBPACK FOOTER //
// ./src/modules/plugins/submenu.js